/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:16:57
*/


const isSwitchAccountModalVisibleReducer = (state = false, action) => {
	if(action.type === 'SET_SWITCH_ACCOUNT_MODAL_TRUE') {
		return true
	} else if(action.type === 'SET_SWITCH_ACCOUNT_MODAL_FALSE') {
		return false
	} else {
		return state
	}
}

export default isSwitchAccountModalVisibleReducer;
